export const LIST_CONTRACT_STRATUM = 'LIST_CONTRACT_STRATUM';
